/*
 * @Description:
 * @Date: 2022-09-23 14:32:56
 */

export const LOGIN_PAGE_PATH = '/login'; // 登录页面地址
export const DEFAULT_PAGE_PATH = ''; // 没有默认页，以menus[0]作为默认页
export const PLATFORM_PORT = 2; // 平台类型，业务端固定2。 1 向日葵 2（工业，服务商，供应商） 3监管
